export const Loader = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.35787 9.79044C4.86751 11.2645 4.88143 12.8598 5.39744 14.3251C5.91345 15.7904 6.90223 17.0424 8.20804 17.884C9.51385 18.7255 11.0625 19.1087 12.6101 18.9734C14.1577 18.838 15.6162 18.1916 16.7561 17.1361C17.8959 16.0806 18.6523 14.6759 18.906 13.1433C19.1597 11.6106 18.8964 10.0371 18.1575 8.67062C17.4187 7.30409 16.2462 6.22218 14.8248 5.59527C13.4034 4.96837 11.8139 4.8321 10.3065 5.20792C9.77067 5.34153 9.22794 5.01543 9.09433 4.47955C8.96072 3.94367 9.28682 3.40094 9.8227 3.26733C11.7607 2.78413 13.8044 2.95933 15.6319 3.76535C17.4594 4.57137 18.9669 5.96241 19.9168 7.71937C20.8668 9.47634 21.2054 11.4994 20.8791 13.4699C20.5529 15.4405 19.5805 17.2465 18.115 18.6036C16.6495 19.9606 14.7741 20.7917 12.7844 20.9657C10.7947 21.1398 8.80353 20.6471 7.12462 19.5651C5.44572 18.4831 4.17444 16.8734 3.51099 14.9894C2.84755 13.1055 2.82966 11.0544 3.46012 9.15915C3.63444 8.6351 4.20059 8.35159 4.72464 8.52592C5.24869 8.70025 5.5322 9.26639 5.35787 9.79044Z"
      fill="currentColor"
    />
  </svg>
);
